import React, { useState } from 'react';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import {
    IconButton,
    CircularProgress,
    Stack,
    Backdrop
} from '@mui/material';


function DescripcionFila(props) {
    let { selectedRowArticulo , imagenCargada , setImagenCargada , onClick , onChange , usuario , cantidad} = props;
    const [isOpen,setIsOpen] = useState(false);
    const [imagenCargadaDialog, setImagenCargadaDialog] = useState(false);


    function onClick_IconCart() {
        //selectedRowArticulo -> viene de <ArticuloList2/>
        //onClick -> viene de <ArticuloList2/> , y llama a onClick_IconCart de <ArticuloList2/>
        onClick(selectedRowArticulo)
    }

   
    function handleChange_CantidadArticulos(e) {     

        let valor = e.target.value;
        let max = e.target.max;
      
        if (!Number(valor)) { //si no es numerico sale
            return;
        }

        if(parseInt(valor) > parseInt(max)) { //si supero el maximo , sale
            return;
        }

        //onChange -> viene de <ArticuloList2/> , y llama a handleChange_CantidadArticulos de <ArticuloList2/>
        onChange(valor)
    }

    //esta funcion me marca toda la casilla de texto pintada en azul
    function handleClick_CantidadArticulos (e)  {
        e.target.select();
    };

    // imagenCargada viene del <ArticuloList2/>
    // setImagenCargada viene del <ArticuloList2/>
    function  handleImageLoaded() {
        if (!imagenCargada) { 
            setImagenCargada(true)
            
        }
    } 

    function handleShowDialog () {
        setImagenCargadaDialog(false)
        setIsOpen(!isOpen);
      };

 
    function  handleImageLoadedDialog() {
       
        if (!imagenCargadaDialog) { 
            setImagenCargadaDialog(true)
        }
    } 


    


    return (
        <div>
            <div className="articuloList2-articuloInfo">
                <div>    
                    <div className="articuloList2-descripcionFila-articuloPhoto">
                        <img
                            src={selectedRowArticulo.pathImagenArticulo ? selectedRowArticulo.pathImagenArticulo + '?' + Date.now() : '/assets/images/imagenes_articulos/sin_imagen.png' + '?' + Date.now() } //selectedRowArticulo -> viene de <ArticuloList2/>
                            onLoad={handleImageLoaded}
                            onClick={handleShowDialog}
                            loading="lazy"
                            style= {{
                                height: !imagenCargada ? '0' : '100%', //si no esta cargada la imagen , pongo el height en 0
                                width: !imagenCargada ? '0' : '100%',  //si no esta cargada la imagen , pongo el width en 0
                                objectFit: 'contain'
                            }} 
                        />
                        {!imagenCargada && ( //si no esta cargada la imagen muestro esto....
                            <div className="image-container-overlay" style={{display: 'flex', justifyContent: 'center'}}>
                                <CircularProgress />
                            </div>
                        )}
                    </div>
                    {isOpen && (
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={isOpen}
                            onClick={handleShowDialog}
                        >   
                            <img
                                src={selectedRowArticulo.pathImagenArticulo ? selectedRowArticulo.pathImagenArticulo + '?' + Date.now() : '/assets/images/imagenes_articulos/sin_imagen.png' + + '?' + Date.now()} //selectedRowArticulo -> viene de <ArticuloList2/>
                                onLoad={handleImageLoadedDialog}
                                onClick={handleShowDialog}
                                loading="lazy"
                                style=  {{
                                            height: !imagenCargadaDialog ? 0 : '500px', //si no esta cargada la imagen , pongo el height en 0
                                            width:  !imagenCargadaDialog && 0          //si no esta cargada la imagen , pongo el width en 0
                                        }}
                            />
                            {!imagenCargadaDialog && ( //si no esta cargada la imagen muestro esto....
                                    <Stack gap={1} justifyContent="center" alignItems="center">
                                        <CircularProgress color="inherit" />
                                    </Stack>
                            )}
                        </Backdrop>
                    )}
                </div>
                <p className="articuloList2-articuloTexto">
                    {/* selectedRowArticulo -> viene de <ArticuloList2/> */}
                    {selectedRowArticulo.codigoArticulo} 
                </p>
                {
                    
                    usuario && //usuario -> viene de <ArticuloList2/> 
                    <div>
                        <div className="articuloList2-articuloTexto">
                            <p className='articuloList2-articuloPrecioCosto'>Precio Costo:</p> ${ selectedRowArticulo.precioListaPorCoeficientePorMedioIva.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) }
                        </div>
                        <div className="articuloList2-articuloTexto">
                            <p className='articuloList2-articuloPrecioUtilidad'>Precio Utilidad:</p> ${ selectedRowArticulo.utilidadArticulo.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) }
                        </div>
                    
                        <p className="articuloList2-articuloTexto">
                            <IconButton aria-label="delete" onClick={onClick_IconCart}>
                                <AddShoppingCartIcon fontSize="large" color="primary" /> 
                            </IconButton>
                                <input 
                                    type="number" 
                                    value={ cantidad  }  // cantidad -> viene de <ArticuloList2/> 
                                    onChange={ e => handleChange_CantidadArticulos(e)} 
                                    min="1"
                                    max="5000"
                                    onClick={e => handleClick_CantidadArticulos(e)}
                                />
                        </p>    
                    </div>
                }     
            </div>
      </div>
    )
  }
  
  export default DescripcionFila;